/**
 * Seo component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

const Seo = ({ description, title }) => {
  const data = useStaticQuery(graphql`
    query seoQuery {
      banner: file(absolutePath: { regex: "/social_banner.png/" }) {
        childImageSharp {
          gatsbyImageData(width: 1200, height: 1200)
        }
      }
      site {
        siteMetadata {
          title
          author {
            name
          }
          description
          social {
            twitter
          }
        }
      }
    }
  `)

  const metaDescription = description || data.site.siteMetadata.description

  return (
    <>
      <title>{`${title} | ${data.site.siteMetadata.title}`}</title>
      <meta name="description" content={metaDescription} />
      <meta name="author" content={data.site.siteMetadata.author.name} />
      <meta name="og:title" content={title} />
      <meta name="og:description" content={metaDescription} />
      <meta name="og:image" content={data.banner.childImageSharp.gatsbyImageData.images.fallback.src} />
      <meta name="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={data.site.siteMetadata.social.twitter} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
    </>
  )
}

Seo.defaultProps = {
  description: ``,
}

Seo.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default Seo
